import { render, staticRenderFns } from "./Spices.vue?vue&type=template&id=2e859c2e&scoped=true&"
import script from "./Spices.vue?vue&type=script&lang=js&"
export * from "./Spices.vue?vue&type=script&lang=js&"
import style0 from "./Spices.vue?vue&type=style&index=0&id=2e859c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e859c2e",
  null
  
)

export default component.exports